/** `pending` holds the word until the server's verdict replaces it; it mutes visually only after a wait. */
export type WordFeedbackKind = '' | 'pending' | 'shake' | 'duplicate' | 'accepted';

const FEEDBACK_MS = 1_000;
/** A verdict arriving sooner than this reads as instant; muting the word first would only make the wait visible. */
export const PENDING_MUTE_DELAY_MS = 150;

/**
 * The current-word line under the board: the word or message being shown, the
 * animation class, and the assistive-technology error text. Outcome feedback clears
 * itself after a moment unless a new selection has started.
 */
export class WordFeedback {
  message = $state('');
  kind = $state<WordFeedbackKind>('');
  error = $state('');
  /** True once a pending word has waited long enough to be shown muted. */
  muted = $state(false);
  /** The submission whose server result may still animate this line. */
  pendingSubmissionId: string | null = null;
  private timer = 0;
  private holdWhile: () => boolean = () => false;

  constructor(holdWhile?: () => boolean) {
    if (holdWhile) this.holdWhile = holdWhile;
  }

  show(message: string, kind: WordFeedbackKind = '', error = ''): void {
    window.clearTimeout(this.timer);
    this.pendingSubmissionId = null;
    this.message = message;
    this.kind = kind;
    this.error = error;
    this.muted = false;
    if (kind === 'pending') {
      this.timer = window.setTimeout(() => {
        if (this.kind === 'pending') this.muted = true;
      }, PENDING_MUTE_DELAY_MS);
    } else if (kind) {
      this.timer = window.setTimeout(() => {
        if (!this.holdWhile()) this.show('');
      }, FEEDBACK_MS);
    }
  }

  clear(): void {
    this.show('');
  }

  dispose(): void {
    window.clearTimeout(this.timer);
  }
}
